(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["openaxis-adaptive-chat"] && !Shopify.designMode) return;
  try {
    const mobileChatMedia = window.matchMedia('(max-width: 767.98px)');
  const mobileChatBars = new Set();
  const mobileChatBarSelector = 'mobile-sticky-bar, .sticky-atc-bar, compare-bar';
  let mobileChatFrame = 0;
  let mobileChatLastClearance = 0;
  let chatCompareWasShown = false;
  let chatCompareLastHeight = 0;

  function applyMobileChatClearance(clearance) {
    mobileChatLastClearance = clearance;
    document.documentElement.style.setProperty('--oa-chat-bottom-clearance', `${clearance}px`);
  }

  function updateMobileChatClearance() {
    mobileChatFrame = 0;
    let clearance = 0;

    let compareShown = false;
    let compareHeight = 0;
    let compareEasing = 'ease';

    mobileChatBars.forEach((bar) => {
      if (!bar.isConnected) {
        mobileChatBars.delete(bar);
        mobileChatResizeObserver.unobserve(bar);
        return;
      }

      const isCompare = bar.matches('compare-bar');
      if (!mobileChatMedia.matches && !isCompare) return;

      const shown = isCompare
        ? document.body.classList.contains('is-product-comparing')
        : bar.matches('mobile-sticky-bar')
          ? document.body.classList.contains('mobile-sticky-bar-up')
          : bar.classList.contains('sticky-atc-bar--show');
      if (!shown) return;

      const style = window.getComputedStyle(bar);
      if (style.display === 'none' || style.position !== 'fixed' || !bar.getClientRects().length) return;

      let bottom = 0;
      if (isCompare) {
        bottom = Math.max(0, Number.parseFloat(style.bottom) || 0);
        compareShown = true;
        compareHeight = Math.max(compareHeight, bar.offsetHeight + bottom);
        compareEasing = style.transitionTimingFunction.split(',')[0] === 'ease' ? 'ease' : 'cubic-bezier(0.4, 0, 0.2, 1)';
      } else if (!bar.matches('mobile-sticky-bar, sticky-atc-bar-minimalist') &&
          document.body.classList.contains('mobile-sticky-bar-up')) {
        const nav = document.querySelector('mobile-sticky-bar');
        if (nav && window.getComputedStyle(nav).display !== 'none') bottom = nav.offsetHeight;
      }
      clearance = Math.max(clearance, bar.offsetHeight + bottom);
    });

    if (clearance !== mobileChatLastClearance) {
      const trayResized = compareShown && chatCompareWasShown && compareHeight !== chatCompareLastHeight;
      document.documentElement.style.setProperty('--oa-chat-motion-duration', trayResized ? '0ms' : '300ms');
      document.documentElement.style.setProperty(
        '--oa-chat-motion-easing',
        compareShown || chatCompareWasShown ? compareEasing : 'cubic-bezier(0.4, 0, 0.2, 1)'
      );
      applyMobileChatClearance(clearance);
    }
    chatCompareWasShown = compareShown;
    chatCompareLastHeight = compareHeight;
  }

  function scheduleMobileChatClearance() {
    if (!mobileChatFrame) mobileChatFrame = requestAnimationFrame(updateMobileChatClearance);
  }

  function syncMobileChatClearance() {
    if (mobileChatFrame) cancelAnimationFrame(mobileChatFrame);
    updateMobileChatClearance();
  }

  const mobileChatResizeObserver = new ResizeObserver(scheduleMobileChatClearance);
  const mobileChatStateObserver = new MutationObserver(syncMobileChatClearance);

  function registerMobileChatBars(root) {
    if (!(root instanceof Element)) return;
    const bars = [...root.querySelectorAll(mobileChatBarSelector)];
    if (root.matches(mobileChatBarSelector)) bars.push(root);
    bars.forEach((bar) => {
      if (mobileChatBars.has(bar)) return;
      mobileChatBars.add(bar);
      mobileChatResizeObserver.observe(bar);
      mobileChatStateObserver.observe(bar, { attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
      bar.addEventListener('transitionend', scheduleMobileChatClearance);
    });
    scheduleMobileChatClearance();
  }

  registerMobileChatBars(document.body);
  mobileChatStateObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  new MutationObserver((records) => {
    records.forEach((record) => record.addedNodes.forEach(registerMobileChatBars));
    scheduleMobileChatClearance();
  }).observe(document.body, { childList: true, subtree: true });
  mobileChatMedia.addEventListener('change', scheduleMobileChatClearance);
  window.addEventListener('resize', scheduleMobileChatClearance, { passive: true });
  window.addEventListener('pageshow', scheduleMobileChatClearance);
  window.visualViewport?.addEventListener('resize', scheduleMobileChatClearance, { passive: true });
  } catch(e) { console.error(e); }
})();

})();
